import { render, staticRenderFns } from "./market-lang.vue?vue&type=template&id=1dc14e33"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VectorLogoFantini: require('/var/www/html/fantini/frontend-2/components/vector/logo/fantini/index.vue').default,VectorIllustrationWorld: require('/var/www/html/fantini/frontend-2/components/vector/illustration/world/index.vue').default,FormLanguageMarket: require('/var/www/html/fantini/frontend-2/components/form/language-market/index.vue').default})
